package io.horion.auth.presentation.ui.components.profile

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.domain.models.AppLanguage
import io.horion.auth.domain.models.ProfileSection
import io.horion.auth.presentation.ui.components.common.LanguageSelector
import io.horion.auth.presentation.ui.components.common.ThemeToggleButton
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import io.horion.auth.presentation.viewmodel.AuthViewModel
import org.jetbrains.compose.web.css.*

@Composable
fun ProfileHeader(
    currentSection: ProfileSection,
    viewModel: AuthViewModel,
) {
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)
    val strings = AppLanguage.strings

    val state = viewModel.uiState
    val fullName = "${state.userFirstName} ${state.userLastName}".trim()


    val userName = when {
        fullName.isNotBlank() -> fullName
        state.userEmail.isNullOrBlank() -> state.userEmail?.substringBefore("@")?.replaceFirstChar { it.uppercase() }
        state.userPhone.isNullOrBlank() -> state.userPhone
        else -> "Utilisateur"
    }

    // Titre et sous-titre selon la section active
    val (sectionTitle, sectionSubtitle) = when (currentSection) {
        ProfileSection.HOME -> strings.sidebarHome to strings.profileHeaderSubtitle
        ProfileSection.PERSONAL_INFO -> strings.personalInfoTitle to strings.personalInfoSubtitle
        ProfileSection.SECURITY -> strings.securityTitle to strings.securitySubtitle
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(leftRight = 32.px, topBottom = 18.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Column(modifier = Modifier.gap(2.px)) {
            SpanText(
                sectionTitle,
                modifier = Modifier
                    .fontSize(AuthTypography.h3)
                    .fontWeight(FontWeight.Bold)
                    .color(colors.onBackground)
            )
            SpanText(
                sectionSubtitle,
                modifier = Modifier
                    .fontSize(AuthTypography.small)
                    .color(colors.mutedText)
            )
        }

        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.gap(12.px)
        ) {
            ThemeToggleButton()

            LanguageSelector()

//            Box(
//                modifier = Modifier.styleModifier { property("position", "relative") },
//                contentAlignment = Alignment.Center
//            ) {
//                Box(
//                    modifier = Modifier
//                        .size(35.px)
//                        .borderRadius(50.percent)
//                        .backgroundColor(colors.inputBg)
//                        .cursor(Cursor.Pointer),
//                    contentAlignment = Alignment.Center
//                ) {
//                    FaBell(modifier = Modifier.fontSize(15.px).color(colors.onBackground))
//                }
//                // Badge "2"
//                Box(
//                    modifier = Modifier
//                        .size(18.px)
//                        .borderRadius(50.percent)
//                        .backgroundColor(colors.primary)
//                        .styleModifier {
//                            property("position", "absolute")
//                            property("top", "-4px")
//                            property("right", "-4px")
//                        },
//                    contentAlignment = Alignment.Center
//                ) {
//                    SpanText(
//                        "2",
//                        modifier = Modifier
//                            .fontSize(9.px)
//                            .fontWeight(FontWeight.Bold)
//                            .color(colors.onPrimary)
//                    )
//                }
//            }

            // Avatar + nom utilisateur + chevron
            Row(
                modifier = Modifier
                    .padding(leftRight = 10.px, topBottom = 6.px)
                    .borderRadius(20.px)
                    .cursor(Cursor.Pointer)
                    .gap(8.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                // Avatar cercle
                Box(
                    modifier = Modifier
                        .size(32.px)
                        .borderRadius(50.percent)
                        .backgroundColor(colors.inputBg)
                        .border(1.px, LineStyle.Solid, colors.border),
                    contentAlignment = Alignment.Center
                ) {
                    FaUser(modifier = Modifier.fontSize(13.px).color(colors.primary))
                }
                SpanText(
                    userName!!,
                    modifier = Modifier
                        .fontSize(AuthTypography.small)
                        .fontWeight(FontWeight.Medium)
                        .color(colors.onBackground)
                )
//                FaChevronDown(modifier = Modifier.fontSize(10.px).color(colors.mutedText))
            }
        }
    }
}

